import { useSiteCountryCode } from '@common/hooks/localisation';

export function useGetApplicationDetailsLink(jobId: string) {
  const countryCode = useSiteCountryCode();

  return `/${countryCode}/jobs/${jobId}/details#applications-list`;
}
